import { useEffect } from "react";
import { styled, ThemeProvider } from "styled-components";
import { debug } from "rtUtils/logger";
import { useConfigStylesTheme, usePostMessageConfig } from "../../hooks/config";
import GlobalStyles from "../GlobalStyles";
import Viewer from "../Viewer";
import QrModeViewer from "../QrModeViewer";

const AppContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const App = ({ qrMode = false }) => {
	const { init, terminate } = usePostMessageConfig();
	const theme = useConfigStylesTheme();

	useEffect(() => {
		if (!qrMode) {
			init();
			debug("VIEWER APP INIT CALLED IN WIDGET MODE");
		}

		return () => {
			if (!qrMode) {
				terminate();
			}
		};
	}, [init]);

	return (
		<ThemeProvider theme={theme}>
			<AppContainer>
				<GlobalStyles/>
				{
					qrMode ?
						<QrModeViewer/> :
						<Viewer/>
				}
			</AppContainer>
		</ThemeProvider>
	);
};

export default App;
